import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="sp-ft-section">
      {/* Ambient Decorative Background Glows */}
      <div className="sp-ft-glow sp-ft-glow-left"></div>
      <div className="sp-ft-glow sp-ft-glow-right"></div>

      <div className="sp-ft-container">
        {/* TOP BRAND & NAVIGATION GRID */}
        <div className="sp-ft-top-grid">
          {/* Brand Identity Column */}
          <div className="sp-ft-brand-col">
            <a href="#home" className="sp-ft-logo-link">
              <img src="./images/logo.svg" alt="ATZ Pay Logo" className="sp-ft-logo-img" />
            </a>
            <p className="sp-ft-brand-desc">
              Smart, safe, and lightning fast everyday payments. Streamlining transactions, global investments, and rewards in one unified workspace.
            </p>
            {/* Live Status Badge */}
            <div className="sp-ft-status-pill">
              <span className="sp-ft-status-dot"></span> All Systems Operational
            </div>
          </div>

          {/* Links Column Group */}
          <div className="sp-ft-links-group">
            <div className="sp-ft-col">
              <h5 className="sp-ft-col-title">Company</h5>
              <ul className="sp-ft-link-list">
                <li><a href="#about" className="sp-ft-link">About Us</a></li>
                <li><a href="#careers" className="sp-ft-link">Careers <span className="sp-ft-hiring-badge">We're Hiring</span></a></li>
                <li><a href="#press" className="sp-ft-link">Press Kit</a></li>
                <li><a href="#contact" className="sp-ft-link">Contact</a></li>
              </ul>
            </div>

            <div className="sp-ft-col">
              <h5 className="sp-ft-col-title">Product</h5>
              <ul className="sp-ft-link-list">
                <li><a href="#payments" className="sp-ft-link">Payments</a></li>
                <li><a href="#cards" className="sp-ft-link">Virtual Cards</a></li>
                <li><a href="#invest" className="sp-ft-link">Investments</a></li>
                <li><a href="#rewards" className="sp-ft-link">Rewards Program</a></li>
              </ul>
            </div>

            <div className="sp-ft-col">
              <h5 className="sp-ft-col-title">Legal &amp; Trust</h5>
              <ul className="sp-ft-link-list">
                <li><a href="#privacy" className="sp-ft-link">Privacy Policy</a></li>
                <li><a href="#terms" className="sp-ft-link">Terms of Service</a></li>
                <li><a href="#security" className="sp-ft-link">Security Standards</a></li>
                <li><a href="#compliance" className="sp-ft-link">Compliance</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* DIVIDER LINE */}
        <div className="sp-ft-divider"></div>

        {/* BOTTOM COPYRIGHT & SOCIAL MEDIA */}
        <div className="sp-ft-bottom-row">
          <p className="sp-ft-copyright">
            © {new Date().getFullYear()} <span className="sp-ft-brand-highlight">ATZ Pay</span>. All rights reserved.
          </p>

          <div className="sp-ft-social-group">
            <a href="#web" aria-label="Website" className="sp-ft-social-btn">
              <span>🌐</span>
            </a>
            <a href="#instagram" aria-label="Instagram" className="sp-ft-social-btn">
              <span>📷</span>
            </a>
            <a href="#youtube" aria-label="YouTube" className="sp-ft-social-btn">
              <span>🎥</span>
            </a>
            <a href="#tiktok" aria-label="TikTok" className="sp-ft-social-btn">
              <span>🎵</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;